import PropTypes from 'prop-types'
import {
  Box,
  Button,
  Center,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
  useToast,
} from '@chakra-ui/react'
import { format } from 'date-fns'
import React, { useCallback, useEffect, useState } from 'react'
import { REPOSITORY } from '../../api/repository/Repository'
import Table from '../Table/Table'
import { colors } from '../../utils/theme/styles'
import Selector from '../Selector/Selector'
import UnderlineHeading from '../UnderlineText/UnderlineHeading'
import { useLoadingContext } from '../../utils/hooks/Context/LoadingContext'
const columns = [
  {
    Header: 'Número de bolsillo',
    accessor: 'sTarjeta',
    type: 'card',
  },
  {
    Header: 'Nombre de colaborador',
    accessor: 'sNombre',
  },
  {
    Header: 'Rut colaborador',
    accessor: 'sRUT',
    type: 'dni',
  },
  {
    Header: 'Monto',
    accessor: 'nMonto',
    type: 'currency',
  },
]
export default function RefillDetail({
  open,
  onClose,
  nAsignacion,
  refill,
  contactOptions,
}) {
  const toast = useToast()
  const { handleOpen, handleClose: handleCloseLoading } = useLoadingContext()
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [reportEmail, setReportEmail] = useState('')
  const [reportEmailError, setReportEmailError] = useState('')

  const isAutomatic = Boolean(refill?.bRecargaAutomatica)

  const handleGetData = useCallback(async () => {
    await REPOSITORY.wsEmpresa.refills.refillDetail(nAsignacion).then((res) => {
      const _data = res.data.map((item) => {
        return {
          ...item,
          sNombre: `${item.sEmpleado} - ${item.sNombre ? item.sNombre : ''}`,
        }
      })
      setData(_data)
      setLoading(false)
    })
  }, [nAsignacion])

  const handleSendReport = useCallback(async () => {
    if (!reportEmail) {
      setReportEmailError('Seleccione un contacto')
      return
    }
    setReportEmailError('')
    handleOpen()
    await REPOSITORY.wsEmpresa.refills
      .sendReportByEmail({
        sEmail: reportEmail,
        sFecha: refill?.dAsignacion || format(new Date(), 'dd-MM-yyyy'),
      })
      .then(() => {
        handleCloseLoading()
        toast({
          title: 'Reporte enviado',
          description: `El reporte fue enviado exitosamente a ${reportEmail}.`,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        })
      })
      .catch(() => handleCloseLoading())
  }, [reportEmail, refill])

  const handleClose = () => {
    setData([])
    setReportEmail('')
    setReportEmailError('')
    onClose()
  }
  useEffect(() => {
    if (open) {
      setLoading(true)
      setReportEmail('')
      setReportEmailError('')
      handleGetData()
    }
  }, [open])

  return (
    <Modal isOpen={open} size="4xl" onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <Text>Detalle de recarga: </Text>
            <Text variant="subtitle1" color={colors.primary.base}>
              {nAsignacion}
            </Text>
          </HStack>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {data.length > 0 && !loading && (
            <Table data={data} columns={columns} />
          )}
          {loading && (
            <Center h="100%" w="100%">
              <Spinner
                w="50px"
                h="50px"
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.200"
                color="blue.500"
              />
            </Center>
          )}
          {!loading && isAutomatic && (
            <Box mt={8} mb={4}>
              <UnderlineHeading
                lineHeight="26px"
                color={colors.gray[800]}
                text={`Enviar reporte por correo (Recarga Automática) — Recarga #${
                  refill?.nAsignacion ?? nAsignacion
                }`}
                variant="h5"
              />
              <HStack
                alignItems="flex-start"
                justifyContent="flex-start"
                spacing="16px"
                mt={6}
              >
                <Box w="300px">
                  <Selector
                    placeholder="Seleccione un contacto"
                    isClearable
                    options={contactOptions}
                    onChange={(value) => {
                      setReportEmail(value || '')
                      if (reportEmailError) setReportEmailError('')
                    }}
                  />
                  {reportEmailError && (
                    <Text fontSize="12px" color="red.500" mt={1}>
                      {reportEmailError}
                    </Text>
                  )}
                </Box>
                <Button onClick={handleSendReport} variant="searchbar">
                  Enviar
                </Button>
              </HStack>
            </Box>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

RefillDetail.propTypes = {
  nAsignacion: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  refill: PropTypes.object,
  contactOptions: PropTypes.array,
}
